@if (row.nbrDiagrammeNote==1)
{
  <img *ngIf="faIcon===''" [src]="srcImg" id="imgBtnDiagrammeNote" width="25" class="img-circle cp"
    (click)="mediaPlayerService.showDiagrammeNote(row)" />

  <i *ngIf="faIcon!==''" [class]="faIcon" severity="secondary"
    (click)="mediaPlayerService.showDiagrammeNote(row)"></i>
}
@if(row.nbrDiagrammeNote>1){
  <span [matBadge]="row.nbrDiagrammeNote"
    matBadgeOverlap="true" matBadgeColor="warn" matBadgeSize="small" [matMenuTriggerFor]="matMenuOptions2"
    matBadgePosition="before">
    <img *ngIf="faIcon===''" [src]="srcImg" id="imgBtnDiagrammeNote" width="25" class="img-circle cp" />
    <i *ngIf="faIcon!==''" [class]="faIcon" severity="secondary"></i>
  </span>

<mat-menu #matMenuOptions2="matMenu" class="profile-menu">
  <div class="noti-list">
    <div class="menu ">
      <div class="user_dw_menu">
        <button mat-menu-item
        *ngFor="let sRow of row.chantMediaDiagrammeNoteMerge; let i = index"
        type="button" icon="pi pi-eye"
        severity="secondary"
        (click)="mediaPlayerService.showDiagrammeNote(sRow)"
        [pTooltip]="'Note ' + (i+1).toString() + (sRow.artistName)"
        tooltipPosition="left">
        <img *ngIf="faIcon===''" [src]="srcImg" id="imgBtnDiagrammeNote" width="25" class="img-circle cp" />
        <i *ngIf="faIcon!==''" [class]="faIcon" severity="secondary"></i> Note {{ (i+1).toString() }}
        <span *ngIf="sRow.artistName!==''" style="font-size: 10px;">{{sRow.artistName}}</span>
        <span *ngIf="sRow.genre==''" style="font-size: 10px;">{{sRow.genre}}</span>
      </button>
    </div>
    </div>
  </div>
</mat-menu>
}
